import { ProfessionListServiceInterface } from 'domain/services';
import { HandleProfessionListUseCaseInterface } from 'domain/usecases';

export class ProfessionService implements ProfessionListServiceInterface {
  constructor(
    private readonly _getProfessionUserUseCase: HandleProfessionListUseCaseInterface,
  ) {}

  async getProfessionList(
    params: HandleProfessionListUseCaseInterface.Params,
  ): Promise<HandleProfessionListUseCaseInterface.Result> {
    return await this._getProfessionUserUseCase.execute(params);
  }
}
